import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Microsoft: React.FC<IconProps & { testid?: string }> = ({ color, size, style, testid }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    width={size ?? '21'}
    height={size ?? '21'}
    fill="none"
    viewBox="0 0 21 21"
    data-testid={`${testid}-icon`}
  >
    <path fill={color ? 'transparent' : '#f3f3f3'} d="M0 0h23v23H0z" />
    <path fill={color ?? '#f35325'} d="M1 1h10v10H1z" />
    <path fill={color ?? '#81bc06'} d="M12 1h10v10H12z" />
    <path fill={color ?? '#05a6f0'} d="M1 12h10v10H1z" />
    <path fill={color ?? '#ffba08'} d="M12 12h10v10H12z" />
  </svg>
);

export default Microsoft;
